import { NoEvidenceCheckComponent } from './pages/no-evidence-check/no-evidence-check.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EvidenceCheckComponent } from './pages/evidence-check/evidence-check.component';
import { BillComponent } from './pages/bill/bill.component';
import { BillImportComponent } from './pages/bill/bill-import/bill-import.component';
import { TruckCostAllocationComponent } from '../transport-operation/pages/truck-cost-allocation/truck-cost-allocation.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    children:[
      {
        path: 'EvidenceCheck',
        component: EvidenceCheckComponent
      },
      {
        path: 'NoEvidenceCheck',
        component: NoEvidenceCheckComponent
      },
      {
        path: 'Bill',
        component: BillComponent
      },
      {
        path: 'BillImport',
        component: BillImportComponent
      },
      {
        path: 'TruckCostAllocation',
        component: TruckCostAllocationComponent
      },
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BillRoutingModule { }
